"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CommandEditDistributionPlan model module.
 * @module model/CommandEditDistributionPlan
 * @version 1.1.3-alpha.1
 */
class CommandEditDistributionPlan {
  /**
   * Constructs a new <code>CommandEditDistributionPlan</code>.
   * @alias module:model/CommandEditDistributionPlan
   * @param id {String} 
   * @param name {String} 
   */
  constructor(id, name) {
    CommandEditDistributionPlan.initialize(this, id, name);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, id, name) {
    obj['id'] = id;
    obj['name'] = name;
  }

  /**
   * Constructs a <code>CommandEditDistributionPlan</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CommandEditDistributionPlan} obj Optional instance to populate.
   * @return {module:model/CommandEditDistributionPlan} The populated <code>CommandEditDistributionPlan</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CommandEditDistributionPlan();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('is_active')) {
        obj['is_active'] = _ApiClient.default.convertToType(data['is_active'], 'Boolean');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('media_list')) {
        obj['media_list'] = _ApiClient.default.convertToType(data['media_list'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CommandEditDistributionPlan</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommandEditDistributionPlan</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CommandEditDistributionPlan.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    // ensure the json data is a string
    if (data['media_list'] && !(typeof data['media_list'] === 'string' || data['media_list'] instanceof String)) {
      throw new Error("Expected the field `media_list` to be a primitive type in the JSON string but got " + data['media_list']);
    }
    return true;
  }
}
CommandEditDistributionPlan.RequiredProperties = ["id", "name"];

/**
 * @member {String} id
 */
CommandEditDistributionPlan.prototype['id'] = undefined;

/**
 * @member {String} name
 */
CommandEditDistributionPlan.prototype['name'] = undefined;

/**
 * @member {Boolean} is_active
 */
CommandEditDistributionPlan.prototype['is_active'] = undefined;

/**
 * @member {String} description
 */
CommandEditDistributionPlan.prototype['description'] = undefined;

/**
 * @member {String} media_list
 */
CommandEditDistributionPlan.prototype['media_list'] = undefined;
var _default = exports.default = CommandEditDistributionPlan;